<iframe [src]="safeUrl" frameborder="0" width="100%" height="300px" allowfullscreen>
</iframe>